import { neutral, shadows } from "../../../components/widgets/tokens.ts"

export const HOME_LIST_MAX_HEIGHT = "calc(100vh - 330px)"

// Recent Projects and Notifications sit on the same light page as the widget
// cards above them, so they carry the same flat card edge rather than floating
// borderless.
export const HOME_PANEL_STYLE = {
  border: `1px solid ${neutral.border}`,
  borderRadius: 12,
  boxShadow: shadows.card
} as const
